import { Environment } from '../app/types';

export const environment: Environment = {
  name: 'development',
  production: false,
  region: 'us-east-1',
  cognitoClientId: '3tbriqivavk3si8ck35odgolqu',
  userPoolId: 'us-east-1_KEHrRZvGS',
  userPoolUrl: 'https://us-east-1kehrrzvgs.auth.us-east-1.amazoncognito.com',
  backendUrl: 'https://oluqvw75hj.execute-api.us-east-1.amazonaws.com/',
};
